/* ==========================================================================
   WOOL & OAK — PDP JavaScript  v2.1 — 2026-04-01
   Scoped to pages with .wo-pdp-active on body
   ========================================================================== */

(function () {
  if (!document.body.classList.contains('wo-pdp-active')) return;

  /* ── Airline Modal — search filter ─────────────────────────────────────── */
  function initAirlineSearch() {
    var search = document.querySelector('.wo-airline-search');
    if (!search) return;
    search.addEventListener('input', function () {
      var q = this.value.toLowerCase();
      var rows = document.querySelectorAll('.wo-airline-table tbody tr');
      rows.forEach(function (row) {
        row.style.display = row.cells[0].textContent.toLowerCase().includes(q) ? '' : 'none';
      });
    });
  }

  /* ── Tab System — transforms accordion-group into horizontal tabs ────── */
  function initTabs() {
    var group = document.querySelector('.wo-pdp-active .accordion-group');
    if (!group || group.querySelector('.wo-tab-bar')) return;
    var items = Array.from(group.querySelectorAll(':scope > .product-info__block-item[data-block-type="accordion"]'));
    var visible = items.filter(function (item) {
      var d = item.querySelector('details.accordion');
      if (!d) return false;
      if (d.classList.contains('Pre-Ord')) return false;
      if (getComputedStyle(item).display === 'none') return false;
      return true;
    });
    if (visible.length < 2) return;

    var bar = document.createElement('div');
    bar.className = 'wo-tab-bar';
    visible.forEach(function (item, i) {
      var t = item.querySelector('.accordion__toggle span');
      var btn = document.createElement('button');
      btn.className = 'wo-tab-btn' + (i === 0 ? ' active' : '');
      btn.textContent = t ? t.textContent.trim() : 'Tab ' + (i + 1);
      btn.setAttribute('data-tab-idx', i);
      bar.appendChild(btn);
    });
    group.insertBefore(bar, group.firstChild);

    visible.forEach(function (item) {
      var d = item.querySelector('details.accordion');
      if (d) d.setAttribute('open', '');
    });

    /* Wrap tab panels in a grid container — all panels stack in same cell,
       tallest one defines height, hidden ones use visibility not display */
    var contentWrap = document.createElement('div');
    contentWrap.className = 'wo-tab-content-wrap';
    visible.forEach(function (item) { contentWrap.appendChild(item); });
    group.appendChild(contentWrap);
    visible.forEach(function (item, i) { if (i > 0) item.classList.add('wo-tab-hidden'); });

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.wo-tab-btn');
      if (!btn) return;
      var idx = parseInt(btn.getAttribute('data-tab-idx'), 10);
      bar.querySelectorAll('.wo-tab-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var barRect = bar.getBoundingClientRect();
      var btnRect = btn.getBoundingClientRect();
      bar.scrollTo({ left: bar.scrollLeft + btnRect.left - barRect.left - (barRect.width - btnRect.width) / 2, behavior: 'smooth' });
      visible.forEach(function (item, i) { item.classList.toggle('wo-tab-hidden', i !== idx); });
    });
  }

  /* ── Bundle Cards — wrap in horizontal scroll row + arrows ───────────── */
  function wrapBundleCards() {
    var container = document.querySelector('.wo-pdp-active .wo-bundle-offers');
    if (!container || container.querySelector('.wo-bundle-cards-row')) return;
    var cards = container.querySelectorAll('.wo-bundle-card');
    if (cards.length < 2) return;
    var row = document.createElement('div');
    row.className = 'wo-bundle-cards-row';
    cards.forEach(function (c) { row.appendChild(c); });
    container.appendChild(row);
  }

  /* ── Bundle Variant Sync — material filter + color sync ────────────────── */
  function initBundleVariantSync() {
    var fmt = window.Shopify && window.Shopify.money_format || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var o = '{{', c = '}}';
      return fmt
        .replace(o + 'amount_with_comma_separator' + c, amount.replace('.', ','))
        .replace(o + 'amount_no_decimals_with_comma_separator' + c, amountNoDecimals)
        .replace(o + 'amount_no_decimals' + c, amountNoDecimals)
        .replace(o + 'amount' + c, amount);
    }

    function getCardData(card) {
      var el = card.querySelector('.wo-bundle-data');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function getMaterial(option1) {
      var h = option1.toLowerCase();
      if (h.indexOf('herringbone') !== -1) return 'herringbone';
      if (h.indexOf('nylon') !== -1) return 'nylon';
      return 'leather';
    }

    function updateItemByColor(card, itemIdx, color) {
      var data = getCardData(card);
      if (!data || !data.items || !data.items[itemIdx]) return;
      var item = data.items[itemIdx];
      var matched = null;
      for (var j = 0; j < item.variants.length; j++) {
        if (item.variants[j].option1 === color) { matched = item.variants[j]; break; }
      }
      if (!matched) return;
      /* UX: crossfade image on swatch change */
      var imgEl = card.querySelector('[data-bundle-item-img="' + itemIdx + '"]');
      if (imgEl && matched.image) {
        imgEl.classList.add('wo-img-swapping');
        setTimeout(function () {
          imgEl.src = matched.image;
          imgEl.onload = function () { imgEl.classList.remove('wo-img-swapping'); };
          /* Fallback if onload doesn't fire (cached image) */
          setTimeout(function () { imgEl.classList.remove('wo-img-swapping'); }, 250);
        }, 150);
      }
      /* UX: crossfade price on change */
      var row = card.querySelector('[data-bundle-item="' + itemIdx + '"]');
      if (row) {
        var priceEl = row.querySelector('[data-bundle-item-price]');
        if (priceEl) {
          priceEl.classList.add('wo-price-updating');
          setTimeout(function () {
            priceEl.innerHTML = formatMoney(matched.price);
            priceEl.classList.remove('wo-price-updating');
          }, 150);
        }
      }
      /* Update color label */
      var label = card.querySelector('[data-bundle-color-label="' + itemIdx + '"]');
      if (label) label.textContent = color;
    }

    /* PDP variant change → sync matching color in bundle cards */
    document.addEventListener('variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.option1) return;
      var color = variant.option1;
      var cards = document.querySelectorAll('.wo-pdp-active [data-bundle-card]');
      cards.forEach(function (card) {
        var data = getCardData(card);
        if (!data || !data.items) return;
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].product_id !== data.main_product_id) continue;
          var hasColor = false;
          for (var j = 0; j < data.items[i].variants.length; j++) {
            if (data.items[i].variants[j].option1 === color) { hasColor = true; break; }
          }
          if (hasColor) {
            updateItemByColor(card, i, color);
            var row = card.querySelector('[data-bundle-item="' + i + '"]');
            if (row) {
              var radio = row.querySelector('.wo-item-radio[data-option1="' + color + '"]');
              if (radio) radio.checked = true;
            }
          }
        }
      });
    });

    /* Low stock urgency — shows per-variant count below variant picker, updates on variant change */
    (function () {
      var dataEl = document.querySelector('[data-variant-inventory]');
      if (!dataEl) return;
      var inv;
      try { inv = JSON.parse(dataEl.textContent); } catch (err) { return; }

      /* Create a single stock badge element below the variant picker */
      var picker = document.querySelector('.wo-pdp-active variant-picker');
      if (!picker) return;
      var badge = document.createElement('p');
      badge.className = 'wo-variant-stock-msg';
      picker.parentElement.insertBefore(badge, picker.nextSibling);

      function updateStockBadge() {
        /* Find currently selected variant ID from the product form */
        var form = document.querySelector('.wo-pdp-active form[action*="/cart/add"]');
        var variantInput = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
        var vid = variantInput ? variantInput.value : null;
        if (!vid || !inv[vid]) { badge.style.display = 'none'; return; }
        var info = inv[vid];
        if (info.managed !== 'shopify' || info.policy !== 'deny' || info.qty <= 0 || info.qty > 10) {
          badge.style.display = 'none'; return;
        }
        badge.textContent = info.option1 + ' \u2014 Only ' + info.qty + ' left';
        badge.style.display = '';
      }

      /* Initial check (delay to let theme set variant ID) */
      setTimeout(updateStockBadge, 500);

      /* Listen for variant changes — theme dispatches 'variant:change' (not 'changed') */
      document.addEventListener('variant:change', function (e) {
        /* The event detail contains the variant directly */
        if (e.detail && e.detail.variant) {
          var vid = String(e.detail.variant.id);
          if (inv[vid]) {
            var info = inv[vid];
            if (info.managed === 'shopify' && info.policy === 'deny' && info.qty > 0 && info.qty <= 10) {
              badge.textContent = info.option1 + ' \u2014 Only ' + info.qty + ' left';
              badge.style.display = '';
              return;
            }
          }
          badge.style.display = 'none';
        }
      });
      /* Fallback: also listen for input changes */
      document.addEventListener('change', function (e) {
        if (e.target.closest('variant-picker') || e.target.name === 'id') setTimeout(updateStockBadge, 100);
      });
    })();

    /* Bundle swatch change → update that item's image/price/label */
    document.addEventListener('change', function (e) {
      if (!e.target.classList.contains('wo-item-radio')) return;
      var card = e.target.closest('[data-bundle-card]');
      var row = e.target.closest('[data-bundle-item]');
      if (!card || !row) return;
      var idx = parseInt(row.getAttribute('data-bundle-item'), 10);
      var color = e.target.getAttribute('data-option1');
      if (!isNaN(idx) && color) updateItemByColor(card, idx, color);
    });

    /* Material button click → update label + benefit text */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.nybut');
      if (!btn) return;
      var material = 'leather';
      if (btn.classList.contains('Nylona')) material = 'nylon';
      if (btn.classList.contains('canvas')) material = 'herringbone';

      /* Update "Material: Full-Grain" label */
      var matLabel = document.querySelector('.mat-selected');
      if (matLabel) {
        var labels = { leather: 'Full-Grain', nylon: 'High Ballistic Nylon', herringbone: 'Stain-Proof Herringbone' };
        matLabel.textContent = labels[material] || '';
      }

      /* Update benefit text below buttons */
      var benefit = document.querySelector('.wo-mat-benefit');
      if (benefit) {
        var benefitKey = material === 'herringbone' ? 'canvas' : material;
        if (benefit.dataset[benefitKey]) benefit.textContent = benefit.dataset[benefitKey];
      }
    });
  }

  /* ── Scroll Arrows — generic for bundle + complementary ──────────────── */
  function injectArrows(headingEl, scrollEl) {
    if (headingEl.querySelector('.wo-scroll-arrows')) return;
    var arrows = document.createElement('div');
    arrows.className = 'wo-scroll-arrows';
    var left = document.createElement('button');
    left.className = 'wo-scroll-arrow';
    left.innerHTML = '\u2039';
    var right = document.createElement('button');
    right.className = 'wo-scroll-arrow';
    right.innerHTML = '\u203A';
    left.addEventListener('click', function () { scrollEl.scrollBy({ left: -200, behavior: 'smooth' }); });
    right.addEventListener('click', function () { scrollEl.scrollBy({ left: 200, behavior: 'smooth' }); });
    arrows.appendChild(left);
    arrows.appendChild(right);
    headingEl.style.display = 'flex';
    headingEl.style.justifyContent = 'space-between';
    headingEl.style.alignItems = 'center';
    headingEl.appendChild(arrows);
  }

  /* ── Sticky CTA — appears when buy buttons scroll out of view ────────── */
  function initStickyCTA() {
    if (document.querySelector('.wo-sticky-cta')) return;
    var buyBtns = document.querySelector('.wo-pdp-active .product-info buy-buttons');
    if (!buyBtns) return;

    var bar = document.createElement('div');
    bar.className = 'wo-sticky-cta wo-sticky-hidden';
    var wrap = document.createElement('div');
    wrap.className = 'wo-sticky-btns';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wo-sticky-atc';
    var priceEl = document.querySelector('.wo-pdp-active .product-info sale-price .money');
    var price = priceEl ? priceEl.textContent.trim() : '';
    btn.textContent = 'ADD TO CART' + (price ? ' \u2014 ' + price : '');
    btn.addEventListener('click', function () {
      var orig = document.querySelector('.wo-pdp-active .product-info buy-buttons button[type="submit"]');
      if (orig) orig.click();
    });
    wrap.appendChild(btn);
    bar.appendChild(wrap);
    document.body.appendChild(bar);

    /* Show sticky bar once user scrolls past the Style Gallery section */
    var trigger = document.querySelector('.wo-pdp-active .product-gallery-wrap') || buyBtns;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.bottom < 0) {
          bar.classList.remove('wo-sticky-hidden');
        } else {
          bar.classList.add('wo-sticky-hidden');
        }
      });
    }, { threshold: 0 }).observe(trigger);
  }

  /* ── "Why the ___" Mobile Carousel (reads from window.__woWhyCards) ── */
  function buildWhyCarousel() {
    if (window.innerWidth >= 1000) return;
    if (document.querySelector('.wo-why-carousel')) return;
    var cfg = window.__woWhyCards;
    if (!cfg || !cfg.heading || !cfg.cards || !cfg.cards[0].title) return;
    var sections = document.querySelectorAll('.wo-pdp-active .shopify-section--multiple-media-with-text');
    if (!sections.length) return;
    var videoUrls = [];
    sections.forEach(function (s) {
      var source = s.querySelector('video source');
      videoUrls.push(source ? source.src : '');
    });
    var total = cfg.cards.length < 10 ? '0' + cfg.cards.length : '' + cfg.cards.length;
    var carousel = document.createElement('div');
    carousel.className = 'wo-why-carousel';
    carousel.innerHTML = '<p class="wo-why-heading">' + cfg.heading + '</p>';
    var strip = document.createElement('div');
    strip.className = 'wo-why-cards';
    cfg.cards.forEach(function (c, i) {
      var num = (i + 1) < 10 ? '0' + (i + 1) : '' + (i + 1);
      var card = document.createElement('div');
      card.className = 'wo-why-card';
      var vid = '';
      if (videoUrls[i]) {
        vid = '<video autoplay muted loop playsinline preload="metadata" class="wo-why-card__video"><source src="' +
          videoUrls[i].replace('HD-1080p-7.2Mbps', 'SD-480p-1.5Mbps') + '" type="video/mp4"></video>';
      }
      card.innerHTML = vid +
        '<div class="wo-why-card__content">' +
        '<span class="wo-why-card__badge">' + num + ' / ' + total + '</span>' +
        '<p class="wo-why-card__title">' + c.title + '</p>' +
        '<p class="wo-why-card__text">' + c.text + '</p>' +
        '<a href="#wo-buy-box" class="wo-why-card__cta">GET YOURS</a></div>';
      strip.appendChild(card);
    });
    carousel.appendChild(strip);
    /* Insert before the before/after slider, Okendo reviews, or at end of main content */
    var anchor = document.querySelector('.wo-pdp-active [id*="before_after"]')
      || document.querySelector('.wo-pdp-active [id*="1728056287229ffa50"]')
      || document.querySelector('.wo-pdp-active .shopify-section--multiple-media-with-text');
    if (anchor) {
      anchor.parentNode.insertBefore(carousel, anchor);
      document.body.classList.add('wo-why-carousel-ready');
    } else {
      var mainSec = document.querySelector('.wo-pdp-active .shopify-section--main-product');
      if (mainSec && mainSec.parentNode) {
        mainSec.parentNode.insertBefore(carousel, mainSec.nextSibling);
        document.body.classList.add('wo-why-carousel-ready');
      }
    }
  }

  /* ── Thumbnail scroll — arrow visibility + wheel capture ─────────── */
  function initThumbGallery() {
    var scroller = document.querySelector('.wo-pdp-active .product-gallery__thumbnail-scroller');
    var list = scroller && scroller.closest('.product-gallery__thumbnail-list');
    if (!scroller || !list) return;

    function check() {
      var atEnd = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 8;
      var noOverflow = scroller.scrollHeight <= scroller.clientHeight + 2;
      list.classList.toggle('wo-thumbs-scrolled-end', atEnd || noOverflow);
    }

    scroller.addEventListener('scroll', check);
    check();
    window.addEventListener('load', check);

    /* Capture wheel events over thumbnails so they scroll independently */
    list.addEventListener('wheel', function (e) {
      var canScroll = scroller.scrollHeight > scroller.clientHeight + 2;
      if (!canScroll) return;
      var atTop = scroller.scrollTop <= 0 && e.deltaY < 0;
      var atBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight < 1 && e.deltaY > 0;
      if (!atTop && !atBottom) {
        e.preventDefault();
        scroller.scrollTop += e.deltaY;
      }
    }, { passive: false });
  }

  /* ── Move Okendo stars into tagline row ───────────────────────────────── */
  function moveStarsToTagline() {
    if (window.innerWidth < 700) return; /* mobile has its own stars */
    var taglineRow = document.querySelector('.wo-pdp-active .wo-tagline-row');
    if (!taglineRow) return;
    var placeholder = taglineRow.querySelector('div:first-child');
    if (!placeholder) return;
    var appBlock = document.querySelector('.wo-pdp-active .product-info__block-item[data-block-type="@app"]');

    function tryMove() {
      var okeSr = document.querySelector('.wo-pdp-active .product-info .oke-sr');
      if (!okeSr) return false;
      if (okeSr.closest('.wo-tagline-row')) return true; /* already in place */
      placeholder.appendChild(okeSr);
      /* Hide app block so Okendo re-renders stay invisible */
      if (appBlock) appBlock.style.display = 'none';
      return true;
    }

    /* MutationObserver: if Okendo re-renders despite hidden container, move again */
    var productInfo = document.querySelector('.wo-pdp-active .product-info');
    if (productInfo) {
      new MutationObserver(function () { tryMove(); })
        .observe(productInfo, { childList: true, subtree: true });
    }

    if (!tryMove()) {
      var attempts = 0;
      var poll = setInterval(function () {
        if (tryMove() || ++attempts > 40) clearInterval(poll);
      }, 250);
    }
  }

  /* ── Pre-order tooltip: hover popup + bold shipping text ─────────────── */
  function initPreorderDot() {
    var pop = document.querySelector('.wo-pdp-active .shipttct .product__pop');
    if (!pop || pop.dataset.woInit) return;
    if (pop.style.display === 'none' || window.getComputedStyle(pop).display === 'none') return;
    pop.dataset.woInit = '1';
    var tooltip = pop.querySelector('.tooltip');
    if (!tooltip) return;

    /* Hide tooltip immediately to prevent flash */
    tooltip.style.cssText = 'opacity:0;pointer-events:none;position:absolute;';

    /* Bold the ESTIMATED SHIPPING line + add discount urgency from variant metafield */
    var html = tooltip.innerHTML;
    html = html.replace(/(ESTIMATED\s+SHIPPING[^.]*\.)/i, '<strong>$1<\/strong>');
    if (html.indexOf('PRE-ORDER') === -1 && typeof pre_order_msg === 'object') {
      var msg = '';
      for (var k in pre_order_msg) { if (pre_order_msg[k]) { msg = pre_order_msg[k]; break; } }
      if (msg) {
        html += '<br><strong style="display:block;margin-top:8px;color:#7a3f0f;">' + msg + '</strong>';
      }
    }
    tooltip.innerHTML = html;

    /* Position tooltip in upper-right of product-info on desktop, above on mobile */
    var isMobile = window.innerWidth < 750;
    var w = 240;
    if (!isMobile) {
      /* Anchor to product-info container so it sits in the upper-right blank space */
      var productInfo = pop.closest('.product-info') || pop.closest('[class*="product-info"]');
      if (productInfo) { productInfo.style.position = 'relative'; productInfo.style.overflow = 'visible'; }
      /* Move tooltip out of shipttct and into product-info */
      if (productInfo && tooltip.parentNode) {
        productInfo.appendChild(tooltip);
      }
    } else {
      var shipRow = pop.closest('.shipttct');
      if (shipRow) { shipRow.style.position = 'relative'; shipRow.style.overflow = 'visible'; }
    }
    var pos = isMobile ? 'right:0;bottom:calc(100% + 8px);' : 'top:60px;right:0;';
    var base = 'position:absolute;width:' + w + 'px;padding:12px 14px;padding-right:24px;font-size:10px;font-family:GaisyrMono,monospace;letter-spacing:0.04em;line-height:1.5;border-radius:8px;background:#ffddce;color:#0a0a0a;box-shadow:0 4px 20px rgba(0,0,0,0.1);z-index:100;transition:opacity 0.3s ease;' + pos;

    var show = function () { tooltip.style.cssText = base + 'opacity:1;pointer-events:auto;'; };
    var hide = function () { tooltip.style.cssText = base + 'opacity:0;pointer-events:none;'; };
    hide();

    /* Close button */
    var x = document.createElement('button');
    x.style.cssText = 'position:absolute;top:4px;right:6px;background:none;border:none;font-size:14px;cursor:pointer;color:#333;padding:2px 4px;line-height:1';
    x.type = 'button';
    x.innerHTML = '&times;';
    tooltip.insertBefore(x, tooltip.firstChild);
    var dismissed = false;
    x.onclick = function (e) { e.stopPropagation(); hide(); dismissed = true; };

    var isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    if (!isTouch) {
      pop.onmouseenter = show;
      pop.onmouseleave = hide;
    } else {
      pop.onclick = function (e) {
        e.preventDefault();
        if (tooltip.style.opacity === '1') { hide(); } else { show(); }
      };
    }

    /* Auto-open when shipping line scrolls into view */
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (ent) {
        if (ent[0].isIntersecting && !dismissed) {
          show();
          obs.disconnect();
          setTimeout(function () { if (!dismissed) hide(); }, isTouch ? 8000 : 5000);
        }
      }, { threshold: 0.5 });
      obs.observe(pop);
    }
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */
  function init() {
    try { initTabs(); } catch (e) { console.warn('wo-pdp: initTabs failed', e); }
    try { initAirlineSearch(); } catch (e) { console.warn('wo-pdp: initAirlineSearch failed', e); }
    try { initThumbGallery(); } catch (e) { console.warn('wo-pdp: initThumbGallery failed', e); }
    try { wrapBundleCards(); } catch (e) { console.warn('wo-pdp: wrapBundleCards failed', e); }
    try { initBundleVariantSync(); } catch (e) { console.warn('wo-pdp: initBundleVariantSync failed', e); }
    try { initStickyCTA(); } catch (e) { console.warn('wo-pdp: initStickyCTA failed', e); }
    try { moveStarsToTagline(); } catch (e) { console.warn('wo-pdp: moveStarsToTagline failed', e); }
    try { initPreorderDot(); } catch (e) { console.warn('wo-pdp: initPreorderDot failed', e); }
    /* Re-try preorder dot on later paints (shipping block may lazy-render) */
    setTimeout(function () { try { initPreorderDot(); } catch (e) {} }, 1000);
    setTimeout(function () { try { initPreorderDot(); } catch (e) {} }, 3000);

    // Drag-to-scroll for pull quotes (desktop)
    var pqScroll = document.querySelector('.wo-pdp-active .wo-pull-quotes');
    if (pqScroll) {
      var isDown = false, startX, scrollLeft;
      pqScroll.addEventListener('mousedown', function (e) {
        isDown = true; pqScroll.classList.add('wo-dragging');
        startX = e.pageX - pqScroll.offsetLeft;
        scrollLeft = pqScroll.scrollLeft;
      });
      pqScroll.addEventListener('mouseleave', function () { isDown = false; pqScroll.classList.remove('wo-dragging'); });
      pqScroll.addEventListener('mouseup', function () { isDown = false; pqScroll.classList.remove('wo-dragging'); });
      pqScroll.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        pqScroll.scrollLeft = scrollLeft - (e.pageX - pqScroll.offsetLeft - startX);
      });
    }

    /* UX: mark unavailable bundle cards */
    document.querySelectorAll('.wo-pdp-active [data-bundle-card]').forEach(function (card) {
      var data = null;
      var el = card.querySelector('.wo-bundle-data');
      if (el) try { data = JSON.parse(el.textContent); } catch (e) {}
      if (!data || !data.items) return;
      var anyAvailable = false;
      for (var i = 0; i < data.items.length; i++) {
        for (var j = 0; j < data.items[i].variants.length; j++) {
          if (data.items[i].variants[j].available) { anyAvailable = true; break; }
        }
        if (anyAvailable) break;
      }
      if (!anyAvailable) {
        card.classList.add('wo-bundle-unavailable');
        var msg = document.createElement('p');
        msg.className = 'wo-bundle-unavailable__msg';
        msg.textContent = 'Currently unavailable';
        card.appendChild(msg);
      }
    });

    // Scroll arrows for bundle + complementary
    var bundleH = document.querySelector('.wo-pdp-active .wo-bundle-offers__heading');
    var bundleR = document.querySelector('.wo-pdp-active .wo-bundle-cards-row');
    if (bundleH && bundleR) injectArrows(bundleH, bundleR);

    var compH = document.querySelector('.wo-pdp-active .complementary-products__header');
    var compR = document.querySelector('.wo-pdp-active .complementary-products__product-list');
    if (compH && compR && !compH.closest('cart-drawer')) injectArrows(compH, compR);

    /* Wire Compare Bags button to the compare drawer */
    var compareBtn = document.querySelector('.wo-pdp-active .wo-compare-btn');
    if (compareBtn) {
      compareBtn.addEventListener('click', function () {
        if (typeof window.woOpenCompareDrawer === 'function') window.woOpenCompareDrawer();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }

  /* ── Bundle ATC — add individual items, skip duplicates ──────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-atc-individual]');
    if (!btn) return;
    var card = btn.closest('[data-bundle-card]');
    if (!card) return;
    var dataEl = card.querySelector('.wo-bundle-data');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!data.items || !data.items.length) return;

    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    /* Determine selected variant ID for each item */
    function getSelectedVariantId(item, itemIdx) {
      /* Check if user picked a swatch */
      var radio = card.querySelector('[data-bundle-item="' + itemIdx + '"] .wo-item-radio:checked');
      var selectedColor = radio ? radio.getAttribute('data-option1') : null;

      /* For the main product, use the PDP's currently selected variant */
      if (item.product_id === data.main_product_id && !selectedColor) {
        var pdpForm = document.querySelector('.wo-pdp-active product-form form, .wo-pdp-active form[id^="product-form"]');
        if (pdpForm) {
          var pdpInput = pdpForm.querySelector('input[name="id"]');
          if (pdpInput) {
            var pdpVid = parseInt(pdpInput.value, 10);
            /* Check if the PDP variant is actually available */
            for (var p = 0; p < item.variants.length; p++) {
              if (item.variants[p].id === pdpVid) {
                if (!item.variants[p].available) {
                  selectedColor = item.variants[p].option1;
                  break; /* fall through to sold-out check below */
                }
                return pdpVid;
              }
            }
          }
        }
      }

      /* Match by color — must be available */
      for (var j = 0; j < item.variants.length; j++) {
        if (selectedColor && item.variants[j].option1 === selectedColor && item.variants[j].available) {
          return item.variants[j].id;
        }
      }
      /* If a color was selected but not available, report it as sold out */
      if (selectedColor) {
        return { soldOut: true, color: selectedColor, title: item.title };
      }
      /* Fallback: first available variant */
      for (var k = 0; k < item.variants.length; k++) {
        if (item.variants[k].available) return item.variants[k].id;
      }
      return null;
    }

    /* Build the list of variant IDs we want to add */
    var wantedItems = [];
    var soldOutItems = [];
    for (var i = 0; i < data.items.length; i++) {
      var vid = getSelectedVariantId(data.items[i], i);
      if (vid && vid.soldOut) {
        soldOutItems.push(vid);
        continue;
      }
      if (vid) wantedItems.push({ id: vid, product_id: data.items[i].product_id });
    }

    /* If any selected variants are sold out, show message instead of adding wrong color */
    if (soldOutItems.length > 0) {
      btn.removeAttribute('aria-busy');
      var names = soldOutItems.map(function (s) { return s.title + ' in ' + s.color; }).join(', ');
      /* Show sold-out message on button */
      btn.classList.add('wo-atc-error');
      var msgEl = document.createElement('span');
      msgEl.className = 'wo-atc-soldout-msg';
      msgEl.textContent = names + ' is sold out — pick another color';
      btn.appendChild(msgEl);
      setTimeout(function () {
        btn.classList.remove('wo-atc-error');
        var msg = btn.querySelector('.wo-atc-soldout-msg');
        if (msg) msg.remove();
        btn.disabled = false;
      }, 4000);
      return;
    }

    /* Collect section IDs the cart drawer needs for re-rendering */
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true, detail: { sections: sectionsToBundle }
    }));
    var sectionsParam = sectionsToBundle.join(',');

    function finishWithDrawer(cartContent, isError) {
      btn.removeAttribute('aria-busy');
      if (isError) {
        /* UX: error state — show message, auto-clear after 3s */
        btn.classList.add('wo-atc-error');
        setTimeout(function () { btn.classList.remove('wo-atc-error'); btn.disabled = false; }, 3000);
        return;
      }
      /* UX: success state — brief confirmation before re-enabling */
      btn.classList.add('wo-atc-success');
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartContent }
      }));
      setTimeout(function () { btn.classList.remove('wo-atc-success'); btn.disabled = false; }, 1500);
    }

    /* Fetch cart, filter out items already present, add the rest */
    fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartProductIds = {};
        cart.items.forEach(function (li) { cartProductIds[li.product_id] = true; });

        var toAdd = wantedItems.filter(function (w) { return !cartProductIds[w.product_id]; });

        if (toAdd.length === 0) {
          /* Everything already in cart — fetch section HTML then open drawer */
          if (!sectionsParam) { finishWithDrawer(cart); return; }
          return fetch(Shopify.routes.root + '?sections=' + sectionsParam)
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              cart.sections = sections;
              finishWithDrawer(cart);
            });
        }

        var payload = {
          items: toAdd.map(function (w) { return { id: w.id, quantity: 1 }; }),
          sections: sectionsParam
        };

        return fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        })
        .then(function (resp) {
          if (!resp || !resp.ok) { finishWithDrawer(null, true); return; }
          return resp.json();
        })
        .then(function (addResponse) {
          if (!addResponse) return;
          return fetch(Shopify.routes.root + 'cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartContent) {
              /* Attach section HTML from the add response */
              if (addResponse.sections) cartContent.sections = addResponse.sections;
              finishWithDrawer(cartContent);
            });
        });
      })
      .catch(function () {
        finishWithDrawer(null, true);
      });
  });

  /* "Why" carousel — retry with increasing delays to handle lazy-loaded sections */
  function tryBuild(delay) {
    setTimeout(function() {
      try { buildWhyCarousel(); } catch (e) { console.warn('wo-pdp: buildWhyCarousel failed', e); }
      if (!document.querySelector('.wo-why-carousel') && delay < 3000) {
        tryBuild(delay * 2);
      }
    }, delay);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { tryBuild(500); });
  } else {
    tryBuild(500);
  }
})();
